import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LexiconModule } from '@galaxy/lexicon';
import En from './en_devel.json';

@NgModule({
  imports: [
    TranslateModule,
    LexiconModule.forChild({
      componentName: 'common/sms',
      baseTranslation: En,
    }),
  ],
})
export class SMSI18NModule {}
